(ns frontend.permissions.team-permissions
  (:require
   [frontend.state.current-session :as session]))

(defn resolve-active-team-members
  [team active-user-ids]
  (->> (:team/members team)
       (keep (fn [aid]
               (get active-user-ids aid)))
       (keep session/get-entity)
       (remove :common/disabled?)))
